import { ITimeOccurrenceDatatype } from '../datastore/time/data_types';
import { TimeOccurrenceEngine } from '../engines/time/time_engine';
import { IQueryMediator } from 'core-ts-types';
import { TimeOccurrenceDataSource } from '../datastore/time/time_datasource';

// Given an array of existing TimeOccurrence blocks, add a new empty TimeOccurrence to the array.
function createDefaultTimeCommandDefinition(
  defineCommand: any,
  ngTimeOccurrenceDataSource: TimeOccurrenceDataSource,
  ngTimeOccurrenceEngine: TimeOccurrenceEngine,
  QueryMediator: IQueryMediator
) {
  return defineCommand('createDefaultTimeCommand', function createDefaultTimeCommand(deferred: any) {
    const newDefaultTimeOccurrence: ITimeOccurrenceDatatype = ngTimeOccurrenceEngine.createDefaultTimeOccurrence();

    QueryMediator.runQueries(ngTimeOccurrenceDataSource);
    deferred.resolve(newDefaultTimeOccurrence);
  });
}

angular.module('ui-ng-calendar').factory('createDefaultTimeCommand', createDefaultTimeCommandDefinition);



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/commands/create_default_time.ts